import { usePublishedData } from "../lib/published-data";
import { useShell } from "../lib/document-route";
import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import authStyles from "../styles/auth.css?url";
import { CustomerAccount } from "../components/auth/customer-account";
import { PodcastFeed } from "../components/auth/podcast-feed";
import { creatorPageHead, shellFrom, withStylesheet } from "../lib/head";
import { keepSearch, searchText } from "../lib/search";
import { loadAccount } from "../server/auth";

/** The signed-in member's account on this site: private and never indexed. */
export const Route = createFileRoute("/account")({
  validateSearch: keepSearch,
  loader: async () => {
    const data = await loadAccount();
    if (data.kind === "missing") throw notFound();
    if (data.kind === "redirect") throw redirect({ href: data.to, statusCode: 302 });
    return data;
  },
  head: ({ matches, loaderData }) => {
    const shell = shellFrom(matches);
    if (!shell || !loaderData) return {};
    return withStylesheet(
      creatorPageHead(shell, {
        pathname: "/account",
        title: `Your account | ${loaderData.creatorName}`,
        description: "Your content, your community, your corner of the internet.",
        noindex: true,
      }),
      authStyles,
    );
  },
  component: Account,
});

function Account() {
  const shell = useShell();
  const { data, failed } = usePublishedData(Route.useLoaderData(), shell, "/account", "account");
  const search = Route.useSearch();
  if (!data.user)
    return (
      <p role="status">
        {failed ? "Your account could not be loaded. Please try again." : "Loading your account…"}
      </p>
    );
  return (
    <>
      <CustomerAccount
        name={data.creatorName}
        user={data.user}
        saved={searchText(search, "saved") || undefined}
        error={searchText(search, "error") || undefined}
        // The prepared site's account data (api/src/site-operations-worker.ts) has no preview.
        preview={!!data.preview}
      />
      {data.podcastCreatorId && <PodcastFeed creatorId={data.podcastCreatorId} />}
    </>
  );
}
